// extracted by mini-css-extract-plugin
export default {"badgeSpacing":"MemberRow_badgeSpacing__OjK5Z"};